import { QuestionCategoryRate } from './../../../../../models/reporting/question-category-rate.model';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as Chart from 'chart.js';
import { ConfigService } from '../../../../../services/config.service';
import { MathRoundHelper } from '../../../../../helpers';

@Component({
  selector: 'app-question-categories-doughnut',
  templateUrl: './question-categories-doughnut.component.html',
  styles: []
})
export class QuestionCategoriesDoughnutComponent implements OnInit, AfterViewInit {
@Input() questionCategoriesRate: QuestionCategoryRate;
@Input() categoryIndex: string;

canvas: any;
canvasId: string;
canvasImgId: string;
ctx: any;
secondColor: string = 'rgb(224, 229, 233)';

private colors = [];
constructor(private readonly configService: ConfigService) {
  this.canvasToImg = this.canvasToImg.bind(this);
  this.drawDoughnutText = this.drawDoughnutText.bind(this);
 }


  ngOnInit() {
    this.colors = this.configService.configData.pieColors;
    this.canvasId = `doughnut_${this.categoryIndex}`;
    this.canvasImgId = `img_${this.canvasId}`;
    
    
  }

  ngAfterViewInit() {
    Chart.pluginService.register({
      beforeDraw: this.drawDoughnutText
    });
    this.canvas = document.getElementById(`doughnut_${this.categoryIndex}`);
    const datasets: Array<Chart.ChartDataSets> = [
      { data: [this.questionCategoriesRate.value, this.questionCategoriesRate.maxValue - this.questionCategoriesRate.value], 
        backgroundColor: [this.colors[+this.categoryIndex.substring(this.categoryIndex.length - 1)], this.secondColor], 
        hoverBackgroundColor: [this.colors[this.categoryIndex], this.secondColor], borderWidth: 0
      }
    ];
    this.ctx = this.canvas.getContext('2d');
    window[`doughnut_${this.categoryIndex}`] = new Chart(this.ctx, {
      type: 'doughnut',
       data: {
          labels: ['a', 'b'],
          datasets: datasets
      },
      options: {
        tooltips: {
          enabled: false
     },
        responsive: true,
        animation: {
          onComplete: this.canvasToImg
        },
        legend: { 
          display: false,
        },
        cutoutPercentage: 70,
        plugins: {
          datalabels: {
              display: false
          }
        }
      }
    });
  }

  drawDoughnutText(chart) {
    const canvasId = this.canvasId;
    const value = MathRoundHelper.roundToFixedNumber(this.questionCategoriesRate.value, 1);
      if (chart.ctx.canvas.id !== canvasId) {
        return;
      }
      const width = chart.canvas.clientWidth;
      const height = chart.canvas.clientHeight;
      const ctx = chart.ctx;
      const fontSize = '1.4em';
      ctx.font = `bold ${fontSize} arial, sans-serif`;
      ctx.textBaseline = 'middle';
      ctx.restore();
       const text = value.toString(),
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
      ctx.fillText(text, textX, textY);
      ctx.save(); 
    }
  
  canvasToImg(animation) {
    const url = animation.chart.toBase64Image();
    document.getElementById(`img_doughnut_${this.categoryIndex}`)['src'] = url;
  }
  
}

